import Router from 'vue-router'

const router = new Router({
  routes: [
    {
      path: '',
      redirect: '/chatQueue'
    },
    {
      path: '/test',
      name: 'test',
      component: () => import('@/views/chat/test')
    },
    {
      path: '/testsaas',
      name: 'testsaas',
      component: () => import('@/views/chat/testsaas')
    },
    {
      path: '/chatQueue',
      name: 'chat-queue',
      component: () => import('@/views/chat/new-chat-queue')
    },
    {
      path: '/chatEngieer',
      name: 'chat-engieer',
      component: () => import('@/views/chat/chat-engieer')
    },
    {
      path: '/webchat',
      name: 'webchat',
      component: () => import('@/views/new-chat-window')
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => import('@/views/login/index')
    },
    {
      path: '/review',
      name: 'review',
      component: resolve => import('@/views/mobile-review/mobile-index')
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/router.js